/*
 * @Author: ZJJ
 * @Date: 2024-12-31 10:11:11
 * @LastEditTime: 2025-11-24 16:58:20
 * @FilePath: /boluo_website/src/api/publicApi.js
 * @Description:
 */
import instances from "./public-axios";
let wanosUser = instances["user"].myRequest;
let wanosUni = instances["uni"].myRequest;

// 登录获取手机号验证码
export function getVerifyCode(params) {
  return wanosUser.get("/api/commonUser/getVerifyCode", params);
}

// 手机号验证码登录(登录注册都走此接口)
export function mobileLogin(params) {
  return wanosUser.post("/api/commonUser/mobileLogin", params);
}

// 手机号验证码注册(忽略此接口，如果是手机号码登录，即使未注册过，也只调佣登录接口)
// export function mobileRegister(params) {
//   return wanosUser.post("/api/commonUser/mobileRegister", params);
// }

// 获取微信二维码链接
export function getUserWechatQrCode(params) {
  return wanosUser.get("/api/commonUser/userWechatQrCode", params);
}

// 微信扫码登录
export function wechatLogin(params) {
  return wanosUser.post("/api/commonUser/wechatLogin", params);
}

// 微信注册并绑定手机号
export function wechatRegisterAndBindMobile(params) {
  return wanosUser.post("/api/commonUser/wechatRegisterAndBindMobile", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 获取专栏列表
export function getColumnsList(params) {
  return wanosUni.get("/v1/columns/list", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 获取有声书列表
export function getAudiobooksList(params) {
  return wanosUni.get("/v1/audiobooks/list", params);
}

// 查询有声书详情
export function getAudiobookDetail(params) {
  return wanosUni.get("/v1/audiobooks/detail", params);
}

// 查询有声书章节列表
export function getAudiobookChapters(params) {
  return wanosUni.get("/v1/audiobooks/chapters", params);
}

// 获取有声书章节详情
export function getAudiobookChapterDetail(params) {
  return wanosUni.get("/v1/audiobook/chapter/detail", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 获取课程列表
export function getLessionsList(params) {
  return wanosUni.get("/v1/lessions/list", params);
}

// 获取课程详情
export function getLessionsDetail(params) {
  return wanosUni.get("/v1/lessions/detail", params);
}

// 获取课程章节列表
export function getLessionsChapters(params) {
  return wanosUni.get("/v1/lessions/chapters", params);
}

// 获取课程章节详情
export function getLessionsChapterDetail(params) {
  return wanosUni.get("/v1/lessions/chapter/detail", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 获取用户推荐列表(推荐有声书或者课程)
export function getRecommendList(params) {
  return wanosUni.get("/v1/user/recommendList", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 获取作者详情
export function getAuthorDetail(params) {
  return wanosUni.get("/v1/author/detail", params);
}

// 获取作者列表
export function getAuthorList(params) {
  return wanosUni.get("/v1/author/list", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 用户关注/取消关注作者
export function createOrCancelFollow(params) {
  return wanosUni.post("/v1/ugc/follow/createOrCancel", params);
}

// 获取作者关注数
export function getFollowCount(params) {
  return wanosUni.get("/v1/ugc/follow/getNum", params);
}

// 用户订阅/取消订阅课程或有声书
export function createOrCancelSubs(params) {
  return wanosUni.post("/v1/ugc/subscribe/createOrCancel", params);
}

// 获取用户订阅数
export function getSubs(params) {
  return wanosUni.get("/v1/ugc/subscribe/getNum", params);
}

// -----------------------------------------------------------------------------------------------------------------------

// 获取订阅列表
export function getSubsList(params) {
  return wanosUni.get("/v1/ugc/subscribe/getList", params);
}

// 获取播放列表
export function getPlayList(params) {
  return wanosUni.get("/v1/ugc/play/getList", params);
}

// 获取购买记录列表
export function getPayList(params) {
  return wanosUni.get("/v1/ugc/purchase/getList", params);
}

// -----------------------------------------------------------------------------------------------------------------------

//  获取商品详情
export function getGoodsInfo(params) {
  return wanosUni.get("/v1/uniOrder/goodsInfo", params);
}

// 创建商品订单
export function createOrder(params) {
  return wanosUni.post("/v1/uniOrder/createUniOrder", params);
}

// 获取订单详情
export function getOrderDetail(params) {
  return wanosUni.get("/v1/uniOrder/getUniOrderDetail", params);
}

// 微信支付
export function wechatAppletPay(params) {
  return wanosUni.post("/v1/uniOrder/wechatNativePay", params);
}

// -----------------------------------------------------------------------------------------------------------------------
